import { newTabDirective } from '~/utils/directives'

// Registers the global `v-new-tab` directive.
//
// Must be a UNIVERSAL plugin (not `.client.ts`): when a directive is registered
// client-only, `resolveDirective('new-tab')` returns undefined during SSR, so
// any SSR-rendered element using `v-new-tab` crashes with
// "Cannot read properties of undefined (reading 'getSSRProps')". Registering it
// on the server too makes the directive resolvable; its DOM work lives in
// mounted/updated, which Vue never runs server-side, so SSR stays a no-op while
// the client behavior (appending the localized `.sr-only` new-tab hint) is
// unchanged.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('new-tab', newTabDirective)
})
